// Русская локализация сообщений об ошибках
export const ru = {
  errors: {
    // Лимиты подписки
    ERR_LIMIT_EXCEEDED: 'Достигнут лимит тарифа "{{tier}}": можно создать не более {{limit}} {{resource}}. Обновите подписку для увеличения лимитов.',
    ERR_LIMIT_EXCEEDED_SIMPLE: 'Достигнут лимит вашего тарифного плана',
    ERR_SOFT_LOCKED: 'Организация заблокирована: grace period истёк. Удалите лишние данные или обновите тариф.',

    // Валидация
    ERR_VALIDATION: 'Ошибка валидации данных',
    ERR_REQUIRED: 'Обязательное поле не заполнено',
    ERR_INVALID_FORMAT: 'Неверный формат данных',
    ERR_ALREADY_EXISTS: 'Объект уже существует',
    ERR_NOT_FOUND: 'Объект не найден',

    // Авторизация
    ERR_UNAUTHORIZED: 'Требуется авторизация',
    ERR_FORBIDDEN: 'Доступ запрещён',

    // Сервер
    ERR_INTERNAL: 'Внутренняя ошибка сервера. Попробуйте позже.',
    ERR_DATABASE: 'Ошибка базы данных',

    // Fallback
    UNKNOWN: 'Неизвестная ошибка',
  },

  // Названия тарифов
  tiers: {
    free: 'FREE',
    standard: 'STANDARD',
    pro: 'PRO',
    academy: 'ACADEMY',
    basic: 'BASIC',
    premium: 'PREMIUM',
  },

  // Ресурсы (для правильного склонения)
  resources: {
    assistants: {
      one: 'направление',
      few: 'направления',
      many: 'направлений',
    },
    athletes: {
      one: 'спортсмена',
      few: 'спортсмена',
      many: 'спортсменов',
    },
    groups: {
      one: 'группу',
      few: 'группы',
      many: 'групп',
    },
    coaches: {
      one: 'тренера',
      few: 'тренера',
      many: 'тренеров',
    },
  },

  gracePeriod: {
    warningTitle: 'Превышены лимиты тарифа',
    warningMessage: 'У вас {{days}} дн. чтобы уменьшить использование или обновить тариф. После этого создание будет заблокировано.',
    lockedTitle: 'Создание заблокировано',
    lockedMessage: 'Превышены лимиты тарифа. Удалите лишние данные или обновите тариф для продолжения.',
    upgradeButton: 'Обновить тариф',
    resourceLabels: {
      athletes: 'Спортсмены',
      assistants: 'Направления',
      groups: 'Группы',
      coaches: 'Тренеры',
    },
  },
}

export type Translations = typeof ru
